




import Vue from 'vue'
import { BaseFormOrderPayment } from '@/components'
import { IShipping, IPaymentMethod, IStateOrder } from '@/models'
import { STORE_MODULES, MUTATIONS_ORDER } from '@/enums'
import { createNamespacedHelpers } from 'vuex'

const { mapState, mapMutations } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'OrderPaymentForm',

    components: { BaseFormOrderPayment },

    props: {
        shipping: {
            type: Object as () => IShipping,
            required: true,
        },
    },

    computed: {
        ...(mapState(['paymentMethod']) as MapStateToComputed<IStateOrder>),

        paymentMethodInternal: {
            get(): IPaymentMethod | undefined {
                return this.paymentMethod
            },
            set(method: IPaymentMethod) {
                this.setPaymentMethod(method)
            },
        },
    },

    async created() {
        this.setPaymentMethod(undefined)
    },

    methods: {
        ...mapMutations({ setPaymentMethod: MUTATIONS_ORDER.SET_PAYMENT_METHOD }),
    },
})
